<template lang="pug">
.v-section-achievements.section-achievements(v-if="data")
	.container
		.section-achievements__block
			.section-achievements__achievement.achievement(
					v-for="(achievement, index) in data.achievements"
					:key="index")
				.achievement__title(v-if="achievement.title" ) {{ achievement.title }}
				.achievement__wrap
					.achievement__number.numbers(v-if="achievement.number" ) {{ achievement.number }}
					h4.achievement__postfix(v-if="achievement.postfix" ) {{ achievement.postfix }}

</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import observer from "../scripts/helpers/observer.js";

export default {

	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;

			this.$nextTick(() => {
				const achievements = document.querySelectorAll('.section-achievements__achievement');
				achievements.forEach(achievement => observer().observe(achievement))
			})
		},

		randomDeg(min, max) {
			return Math.floor(Math.random() * (max - min + 1)) + min;
		}
	},

}

</script>